module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "dialog-mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-menu",
    on: {
      "click": _vm.close
    }
  }, [_c('div', {
    staticClass: "dialog-ctx-1"
  }, [_c('div', {
    staticClass: "cont-1"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgSrc
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contents"
  }, [_vm._v(_vm._s(_vm.title))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3387d892"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/provincial_level/qrcode_dialog/qrcode_dialog.vue
// module id = 314
// module chunks = 40